/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompantOfficeTypeListResposne } from '../../models/compant-office-type-list-resposne';

export interface OfficeControllerFindAllOfficeTypes$Params {
  limit?: number;
  skip?: number;
}

export function officeControllerFindAllOfficeTypes(http: HttpClient, rootUrl: string, params?: OfficeControllerFindAllOfficeTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompantOfficeTypeListResposne;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFindAllOfficeTypes.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompantOfficeTypeListResposne;
      }>;
    })
  );
}

officeControllerFindAllOfficeTypes.PATH = '/company/office/types';
